import React from 'react';
import { LayoutDashboard, FileText, Users, User, LogOut, TrendingUp, Clock, CheckCircle, Star, Calendar, CreditCard, MessageCircle, Shield, ChevronRight, Bell } from 'lucide-react';

export function StatCard({icon, label, value, color, bg, trend, onClick}) {
  return (
    <div onClick={onClick} style={{background:'white',borderRadius:'10px',padding:'20px 22px',border:'1px solid #e8eaed',cursor:onClick?'pointer':'default',transition:'all 0.15s'}}
      onMouseEnter={e=>{if(onClick){e.currentTarget.style.borderColor='#d1d5db';e.currentTarget.style.boxShadow='0 2px 8px rgba(0,0,0,0.06)';}}}
      onMouseLeave={e=>{e.currentTarget.style.borderColor='#e8eaed';e.currentTarget.style.boxShadow='none';}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'14px'}}>
        <div style={{width:'36px',height:'36px',borderRadius:'8px',background:bg,display:'flex',alignItems:'center',justifyContent:'center'}}>{icon}</div>
        {trend&&<span style={{fontSize:'11px',color:'#16a34a',fontWeight:'600'}}>{trend}</span>}
      </div>
      <div style={{color:'#0f172a',fontSize:'26px',fontWeight:'700',letterSpacing:'-0.5px',marginBottom:'3px'}}>{value}</div>
      <div style={{color:'#6b7280',fontSize:'12px',fontWeight:'500'}}>{label}</div>
    </div>
  );
}

export function Badge({status}) {
  const cfg={
    live:{bg:'#dcfce7',c:'#16a34a',dot:'#16a34a'},
    pending:{bg:'#fef9c3',c:'#ca8a04',dot:'#ca8a04'},
    closed:{bg:'#fee2e2',c:'#dc2626',dot:'#dc2626'},
    active:{bg:'#dcfce7',c:'#16a34a',dot:'#16a34a'},
    immediate:{bg:'#dbeafe',c:'#2563eb',dot:'#2563eb'},
    inactive:{bg:'#f1f5f9',c:'#64748b',dot:'#94a3b8'},
    evaluated:{bg:'#ede9fe',c:'#7c3aed',dot:'#7c3aed'},
    shortlisted:{bg:'#dcfce7',c:'#16a34a',dot:'#16a34a'},
    rejected:{bg:'#fee2e2',c:'#dc2626',dot:'#dc2626'},
    interviewed:{bg:'#dbeafe',c:'#2563eb',dot:'#2563eb'},
  };
  const s=cfg[status]||cfg.pending;
  return (
    <span style={{display:'inline-flex',alignItems:'center',gap:'5px',padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'600',background:s.bg,color:s.c}}>
      <span style={{width:'5px',height:'5px',borderRadius:'50%',background:s.dot}}/>
      {status?.toUpperCase()}
    </span>
  );
}

export function EmptyState({icon, title, desc, action}) {
  return (
    <div style={{textAlign:'center',padding:'60px 20px'}}>
      <div style={{fontSize:'48px',marginBottom:'16px'}}>{icon}</div>
      <h3 style={{color:'#1e293b',fontSize:'16px',fontWeight:'600',margin:'0 0 8px'}}>{title}</h3>
      <p style={{color:'#94a3b8',fontSize:'14px',margin:'0 0 24px'}}>{desc}</p>
      {action}
    </div>
  );
}

export function PageHeader({title, subtitle, action}) {
  return (
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'24px'}}>
      <div>
        <h1 style={{color:'#0f172a',fontSize:'22px',fontWeight:'700',margin:'0 0 4px',letterSpacing:'-0.3px'}}>{title}</h1>
        {subtitle&&<p style={{color:'#64748b',fontSize:'14px',margin:0}}>{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
